import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface SendTestEventResult {
  status: 'success' | 'failed';
}

export const useSendTestEventTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.webhook.sendTestEvent.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.webhook.deliveryLog.list.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.webhook.list.queryKey(),
        });
      },
    }),
  });

  return {
    sendTestEvent: async (id: string): Promise<SendTestEventResult> => {
      const result = await mutation.mutateAsync({ id });

      return { status: result.status };
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
